// extracted by mini-css-extract-plugin
export var description = "hC_p";
export var iconContainer = "hC_fR";
export var label = "hC_bf";
export var navItemContainer = "hC_qy";
export var textContainer = "hC_dk";